/* =========================================================
   SAKINA — JavaScript du thème
   Vanilla, sans dépendance. Tout est progressif : sans JS,
   les formulaires postent normalement et les liens naviguent.
   ========================================================= */
(function () {
  'use strict';

  var T = window.SakinaTheme || {};
  var routes = T.routes || {};

  /* ---------- Utilitaires ---------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function on(root, type, sel, handler) {
    root.addEventListener(type, function (e) {
      var el = e.target.closest(sel);
      if (el && root.contains(el)) handler(e, el);
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function formatMoney(cents) {
    var fmt = T.moneyFormat || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100);
    var withComma = amount.toFixed(2).replace('.', ',');
    var withPeriod = amount.toFixed(2);
    var noDecimals = Math.round(amount).toString();
    return fmt
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimals)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', withPeriod);
  }

  var scrollLocks = 0;
  function lockScroll(lock) {
    scrollLocks = Math.max(0, scrollLocks + (lock ? 1 : -1));
    document.documentElement.style.overflow = scrollLocks > 0 ? 'hidden' : '';
  }

  function trapFocus(container, previouslyFocused) {
    var selector = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

    function handle(e) {
      if (e.key !== 'Tab') return;
      var items = $$(selector, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    container.addEventListener('keydown', handle);
    return function release() {
      container.removeEventListener('keydown', handle);
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    };
  }

  /* ---------- Accordéons ---------- */

  function initAccordions() {
    on(document, 'click', '.accordion__trigger', function (e, trigger) {
      var panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;
      var open = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!open));
      panel.setAttribute('data-open', String(!open));
    });
  }

  /* ---------- Menu mobile ---------- */

  function initMobileMenu() {
    var menu = $('#mobile-menu');
    if (!menu) return;
    var release = null;

    function open() {
      var opener = document.activeElement;
      menu.hidden = false;
      lockScroll(true);
      $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      release = trapFocus(menu, opener);
      var first = $('a, button', menu);
      if (first) first.focus();
    }

    function close() {
      menu.hidden = true;
      lockScroll(false);
      $$('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (release) { release(); release = null; }
    }

    on(document, 'click', '[data-menu-toggle]', function (e) { e.preventDefault(); open(); });
    on(document, 'click', '[data-menu-close]', function (e) { e.preventDefault(); close(); });
    on(menu, 'click', 'a', function () { close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) close();
    });
  }

  /* ---------- Panier ---------- */

  var Cart = {
    busy: false,

    drawer: function () { return $('#cart-drawer'); },

    open: function () {
      var drawer = Cart.drawer();
      var overlay = $('#drawer-overlay');
      if (!drawer || !overlay) return;
      var opener = document.activeElement;
      drawer.hidden = false;
      overlay.hidden = false;
      requestAnimationFrame(function () {
        drawer.setAttribute('data-open', 'true');
        overlay.setAttribute('data-open', 'true');
      });
      lockScroll(true);
      Cart.release = trapFocus(drawer, opener);
      var close = $('[data-cart-close]', drawer);
      if (close) close.focus();
    },

    close: function () {
      var drawer = Cart.drawer();
      var overlay = $('#drawer-overlay');
      if (!drawer || !overlay) return;
      drawer.setAttribute('data-open', 'false');
      overlay.setAttribute('data-open', 'false');
      lockScroll(false);
      if (Cart.release) { Cart.release(); Cart.release = null; }
      setTimeout(function () {
        if (drawer.getAttribute('data-open') !== 'true') { drawer.hidden = true; overlay.hidden = true; }
      }, 300);
    },

    applySections: function (sections) {
      if (!sections) return;
      var html = sections['cart-drawer'];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('#cart-drawer-content');
      var current = $('#cart-drawer-content');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        Cart.updateCount(parseInt(fresh.getAttribute('data-count'), 10));
      }
    },

    updateCount: function (count) {
      if (isNaN(count)) return;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = count === 0;
      });
    },

    request: function (url, body) {
      body.sections = 'cart-drawer';
      body.sections_url = window.location.pathname;
      Cart.busy = true;
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) throw new Error(data.description || data.message);
          Cart.applySections(data.sections);
          return data;
        })
        .finally(function () { Cart.busy = false; });
    },

    add: function (items) {
      return Cart.request(routes.cart_add, { items: items });
    },

    change: function (line, quantity) {
      return Cart.request(routes.cart_change, { line: line, quantity: quantity });
    },

    updateAttributes: function (attributes) {
      return Cart.request(routes.cart_update, { attributes: attributes });
    }
  };

  function initCart() {
    var drawerEnabled = T.cartDrawer !== false && $('#cart-drawer');

    if (drawerEnabled) {
      on(document, 'click', '[data-cart-toggle]', function (e) {
        e.preventDefault();
        Cart.open();
      });
    }

    on(document, 'click', '[data-cart-close]', function (e) { e.preventDefault(); Cart.close(); });
    on(document, 'click', '#drawer-overlay', function () { Cart.close(); });
    document.addEventListener('keydown', function (e) {
      var drawer = Cart.drawer();
      if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') Cart.close();
    });

    /* Quantités */
    on(document, 'click', '[data-qty-change]', function (e, btn) {
      e.preventDefault();
      if (Cart.busy) return;
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qty = parseInt(btn.getAttribute('data-qty-change'), 10);
      Cart.change(line, qty).catch(showError);
    });

    on(document, 'change', '[data-qty-input]', function (e, input) {
      var line = parseInt(input.getAttribute('data-line'), 10);
      var qty = Math.max(0, parseInt(input.value, 10) || 0);
      Cart.change(line, qty).catch(showError);
    });

    on(document, 'click', '[data-cart-remove]', function (e, btn) {
      e.preventDefault();
      Cart.change(parseInt(btn.getAttribute('data-line'), 10), 0).catch(showError);
    });

    /* Upsell */
    on(document, 'click', '[data-cart-upsell-add]', function (e, btn) {
      e.preventDefault();
      btn.disabled = true;
      Cart.add([{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }])
        .catch(showError)
        .finally(function () { btn.disabled = false; });
    });

    /* Emballage cadeau */
    on(document, 'change', '[data-gift-toggle]', function (e, input) {
      var wrap = $('[data-gift-message]');
      if (wrap) wrap.hidden = !input.checked;
      var variantId = parseInt(input.getAttribute('data-variant-id'), 10);
      var line = parseInt(input.getAttribute('data-line'), 10);
      if (input.checked) {
        if (!variantId) return;
        Cart.add([{ id: variantId, quantity: 1 }]).catch(showError);
      } else if (line) {
        Cart.change(line, 0).catch(showError);
      }
    });

    on(document, 'input', '[data-gift-message-input]', debounce(function (e, input) {
      Cart.updateAttributes({ 'Message cadeau': input.value }).catch(function () {});
    }, 700));
  }

  function showError(err) {
    var box = $('[data-cart-error]');
    var message = (err && err.message) || T.strings.error || 'Une erreur est survenue.';
    if (box) {
      box.textContent = message;
      box.hidden = false;
    } else {
      console.error(message);
    }
  }

  /* ---------- Formulaire produit ---------- */

  function initProductForm() {
    /* La case « emballage cadeau » révèle le champ message et ajoute
       le produit cadeau dans le même appel que le tabouret. */
    on(document, 'change', '[data-gift-addon]', function (e, input) {
      var scope = input.closest('[data-buybox]') || document;
      var field = $('[data-gift-addon-message]', scope);
      if (field) field.hidden = !input.checked;
    });

    $$('[data-product-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (T.cartDrawer === false || !$('#cart-drawer')) return; /* navigation normale */
        e.preventDefault();
        var button = $('[type="submit"]', form);
        var label = button ? button.textContent : '';
        if (button) { button.setAttribute('aria-disabled', 'true'); button.textContent = '…'; }

        var formData = new FormData(form);
        var items = [{
          id: parseInt(formData.get('id'), 10),
          quantity: parseInt(formData.get('quantity') || '1', 10),
          properties: {}
        }];
        formData.forEach(function (value, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && value) items[0].properties[m[1]] = value;
        });
        if (!Object.keys(items[0].properties).length) delete items[0].properties;

        var giftBox = $('[data-gift-addon]', form.closest('[data-buybox]') || document);
        if (giftBox && giftBox.checked) {
          var giftId = parseInt(giftBox.getAttribute('data-variant-id'), 10);
          if (giftId) items.push({ id: giftId, quantity: 1 });
        }

        Cart.add(items)
          .then(function () { Cart.open(); })
          .catch(showError)
          .finally(function () {
            if (button) { button.removeAttribute('aria-disabled'); button.textContent = label; }
          });
      });
    });
  }

  /* ---------- Sélecteur de pack (variantes) ---------- */

  function initPackSelector() {
    $$('[data-packs]').forEach(function (group) {
      var form = group.closest('form');
      /* Une page d'accueil mono-produit peut porter plusieurs blocs d'achat :
         chacun met à jour ses propres prix, jamais ceux du voisin. */
      var box = group.closest('[data-buybox]') || document;
      var stickyBar = $('[data-sticky-bar]');
      var isPrimary = box.closest('[data-sticky-anchor]') !== null;

      group.addEventListener('change', function (e) {
        var input = e.target.closest('input[type="radio"]');
        if (!input) return;

        var id = input.value;
        var price = parseInt(input.getAttribute('data-price'), 10);
        var compare = parseInt(input.getAttribute('data-compare'), 10);
        var available = input.getAttribute('data-available') === 'true';

        if (form) {
          var hidden = $('input[name="id"]', form);
          if (hidden) hidden.value = id;
          var submit = $('[type="submit"]', form);
          if (submit) {
            submit.disabled = !available;
            submit.textContent = available ? submit.getAttribute('data-label') : (T.strings.soldOut || 'Épuisé');
          }
        }

        var scopes = [box];
        if (isPrimary && stickyBar) scopes.push(stickyBar);

        scopes.forEach(function (scope) {
          $$('[data-price-current]', scope).forEach(function (el) { el.textContent = formatMoney(price); });
          $$('[data-price-compare]', scope).forEach(function (el) {
            if (compare && compare > price) { el.textContent = formatMoney(compare); el.hidden = false; }
            else { el.hidden = true; }
          });
          $$('[data-price-save]', scope).forEach(function (el) {
            if (compare && compare > price) { el.textContent = '−' + formatMoney(compare - price); el.hidden = false; }
            else { el.hidden = true; }
          });
        });

        if (isPrimary) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Galerie produit ---------- */

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var rail = $('[data-gallery-rail]', gallery);
      var dots = $$('[data-gallery-dot]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      if (!rail) return;

      function setActive(index) {
        dots.forEach(function (d, i) {
          var dot = $('.gallery__dot', d) || d;
          dot.setAttribute('aria-current', String(i === index));
        });
        thumbs.forEach(function (t, i) { t.setAttribute('aria-current', String(i === index)); });
      }

      function goTo(index) {
        var slide = rail.children[index];
        if (slide) rail.scrollTo({ left: slide.offsetLeft - rail.offsetLeft, behavior: 'smooth' });
      }

      rail.addEventListener('scroll', debounce(function () {
        var index = Math.round(rail.scrollLeft / rail.clientWidth);
        setActive(index);
      }, 80), { passive: true });

      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          goTo(i);
          setActive(i);
        });
      });

      setActive(0);
    });
  }

  /* ---------- Compte à rebours du panier ---------- */

  function initCartTimer() {
    var el = $('[data-cart-timer]');
    if (!el) return;
    var out = $('[data-cart-timer-value]', el);
    var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 15;
    var KEY = 'sakina-cart-deadline';

    /* L'échéance est posée une seule fois et conservée pour la session :
       elle ne doit pas repartir à zéro à chaque ouverture du tiroir. */
    var deadline = parseInt(sessionStorage.getItem(KEY) || '0', 10);
    if (!deadline || deadline < Date.now()) {
      deadline = Date.now() + minutes * 60000;
      try { sessionStorage.setItem(KEY, String(deadline)); } catch (e) {}
    }

    function tick() {
      var left = Math.max(0, deadline - Date.now());
      if (left === 0) {
        el.hidden = true;
        clearInterval(timer);
        return;
      }
      var total = Math.round(left / 1000);
      var m = Math.floor(total / 60);
      var sec = total % 60;
      out.textContent = m + ':' + (sec < 10 ? '0' : '') + sec;
      el.hidden = false;
    }

    var timer = setInterval(tick, 1000);
    tick();
  }

  /* ---------- Carrousels à flèches ---------- */

  function initRails() {
    $$('[data-rail]').forEach(function (rail) {
      var wrap = rail.parentElement;
      var prev = $('[data-rail-prev]', wrap);
      var next = $('[data-rail-next]', wrap);
      if (!prev || !next) return;

      function step() {
        var first = rail.firstElementChild;
        return first ? first.offsetWidth + 16 : rail.clientWidth;
      }

      function sync() {
        var max = rail.scrollWidth - rail.clientWidth - 2;
        prev.disabled = rail.scrollLeft <= 2;
        next.disabled = rail.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', debounce(sync, 80), { passive: true });
      window.addEventListener('resize', debounce(sync, 150));
      sync();
    });
  }

  /* ---------- Barre d'achat collante (mobile) ---------- */

  function initStickyBar() {
    var bar = $('[data-sticky-bar]');
    var anchor = $('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    /* Pas de rootMargin négatif : il réduirait la zone d'observation à une
       hauteur nulle, l'élément ne serait jamais « intersectant » et le
       callback ne se déclencherait plus jamais après le premier appel.
       On observe le bloc d'achat tel quel : la barre apparaît quand il est
       entièrement passé au-dessus de l'écran. */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        bar.setAttribute('data-visible', String(scrolledPast));
      });
    }, { threshold: 0 });

    observer.observe(anchor);
  }

  /* ---------- Initialisation ---------- */

  function init() {
    initAccordions();
    initMobileMenu();
    initCart();
    initProductForm();
    initPackSelector();
    initGallery();
    initRails();
    initCartTimer();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Ré-initialisation dans l'éditeur de thème */
  document.addEventListener('shopify:section:load', init);
})();
